<div *ngIf="showEdit == false">
  <h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Análisis de demanda
  </h1>

  <!-- Heading -->
  <div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
      <p class="mb-0">
        <span class="grey-text">Facturación masiva</span>
        <span> /</span>
        <span>Análisis de demanda</span>
      </p>
    </div>
  </div>
  <!-- Heading -->

  <!-- Cabecera de botones -->
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="card mb-2 wow detalle-cliente">
      <div class="card-body justify-content-between">
        <div class="row filtros-body">
          <div class="col d-flex align-items-center" style="max-width: 20%;">
            <!-- Material checked -->
            <div class="form-check">
              <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
                [value]="RB_TIPO_VISTA_RESUMEN" />
              <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
            </div>
            <!-- Material unchecked -->
            <div class="form-check">
              <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
                [value]="RB_TIPO_VISTA_DETALLE" />
              <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
            </div>
          </div>

          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                formControlName="fechaDesde"></mdb-date-picker>
              <div *ngIf="
                                formHeader.get('fechaDesde').invalid &&
                                (formHeader.get('fechaDesde').dirty ||
                                formHeader.get('fechaDesde').touched)
                            ">
                <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                formControlName="fechaHasta"></mdb-date-picker>
              <div *ngIf="
                                formHeader.get('fechaHasta').invalid &&
                                (formHeader.get('fechaHasta').dirty ||
                                formHeader.get('fechaHasta').touched)
                              ">
                <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 300px;">
            <div class="md-form">
              <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Seleccionar bodega" formControlName="bodega" required>
              </mdb-select>
              <label>Bodega</label>
              <div *ngIf="
                                formHeader.get('bodega').invalid &&
                                (formHeader.get('bodega').dirty ||
                                formHeader.get('bodega').touched)
                              ">
                <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                  Ingrese bodega
                </mdb-error>
              </div>
            </div>
          </div>

          <ng-container *ngIf="permiteUnidadNegocio">
            <div class="col" style="max-width: 300px;">
              <div class="md-form">
                <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                  placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                </mdb-select>
                <div *ngIf="
                                formHeader.get('unidad_negocio_codigo').invalid &&
                                (formHeader.get('unidad_negocio_codigo').dirty ||
                                formHeader.get('unidad_negocio_codigo').touched)
                              ">
                  <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">
                    Ingrese unidad de negocio
                  </mdb-error>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
      <!-- FOOTER -->
      <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
        <div></div>
        <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="buscar(1)">
          Analizar pedidos
        </button>
      </div>
    </div>
  </form>

  <div class="card mb-2 wow detalle-cliente" *ngIf="listaMovimientosResumen">
    <div class="card-body justify-content-between">
      <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox [(ngModel)]="CheckBoxAllValueResumen" (change)="checkAllChange($event)"
                  [checked]="true"></mdb-checkbox>
              </th>
              <th scope="col">Cod. Producto</th>
              <th scope="col">Descripción</th>
              <th scope="col">Formato</th>
              <th scope="col">Cantidad</th>
              <!-- <th scope="col">Stock</th> -->
              <!-- <th scope="col" class="text-center">Disponibilidad</th> -->
              <th scope="col">Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="100%" style="text-align: center">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
            </tr>
            <tr *ngIf="!loading && listaMovimientosResumen?.length === 0">
              <td colspan="100%" style="text-align: center">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let movimiento of listaMovimientosResumen">
              <td>
                <mdb-checkbox [checked]="movimiento.additionalInfo.checked"
                  (change)='checkDetalle(movimiento.additionalInfo, $event, movimiento)'>
                </mdb-checkbox>
              </td>
              <td>{{movimiento.skuProducto}}</td>
              <td>{{movimiento.descripcion}}</td>
              <td>{{movimiento.formato}}</td>
              <td>{{movimiento.cantidad | numerico}}</td>

              <td>
                <mdb-badge pill="true" info="true" *ngIf="movimiento.estadoAnalisisCodigo === 0">
                  {{movimiento.estado}}</mdb-badge>

                <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                  (click)="loadAndShowModalDetalleMov(movimiento)" *ngIf="movimiento.estadoAnalisisCodigo === 1">
                  {{movimiento.estado}}
                </button>
                <mdb-badge pill="true" warning="true" *ngIf="movimiento.estadoAnalisisCodigo === 2">
                  {{movimiento.estado}}</mdb-badge>
                <!-- Quiebre con algo atendido => Atendible Parcialmente (amarillo) -->
                <mdb-badge pill="true" warning="true"
                  *ngIf="movimiento.estadoAnalisisCodigo === 3 && movimiento.diferenciaConStock < movimiento.cantidad">
                  Atendible Parcialmente
                  {{movimiento.diferenciaConStock | numerico}}
                </mdb-badge>
                <!-- Quiebre total: nada atendido (rojo) -->
                <mdb-badge pill="true" danger="true"
                  *ngIf="movimiento.estadoAnalisisCodigo === 3 && movimiento.diferenciaConStock >= movimiento.cantidad">
                  {{movimiento.estado}}
                  {{movimiento.diferenciaConStock | numerico}}
                </mdb-badge>
              </td>
              <td>
                <button mdbBtn type="button" color="default" mdbWavesEffect class="btn text-center" size="sm"
                  [ngClass]="{'invisible': movimiento.estadoAnalisisCodigo !== 3}"
                  (click)="loadAndShowModalCambioProducto(movimiento)">
                  Cambiar
                </button>
                <button mdbBtn type="button" color="info" mdbWavesEffect class="btn" size="sm"
                  (click)="loadAndShowModalPedidos(movimiento.detalleAnalisisDemanda)">
                  Pedidos
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <app-pagination [context]="paginationContextResumen" (onPageChange)="onPageChangeResumen($event)"
          *ngIf="listaMovimientosResumen?.length > 0"></app-pagination>
      </div>


      <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox [(ngModel)]="CheckBoxAllValue" (change)="checkAllChange($event)"
                  [checked]="true"></mdb-checkbox>
              </th>
              <th scope="col">Cod. Producto</th>
              <th scope="col">Descripción</th>
              <th scope="col">Nota vta.</th>
              <th scope="col">Rut</th>
              <th scope="col">Nombre</th>
              <th scope="col">Comuna</th>
              <th scope="col">Vendedor</th>
              <th scope="col">Formato</th>
              <th scope="col">Cantidad</th>
              <th scope="col">Stock</th>
              <th scope="col" class="text-center">Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tbody>
          <tbody *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tbody>
          <tbody class="" *ngFor="let listmov of listaMovimientos">
            <ng-container *ngIf="!loading">
              <tr>
                <td></td>
                <td style="font-weight: bold;">{{listmov.skuProducto}}</td>
                <td style="font-weight: bold;">{{listmov.nombreProducto}}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>

              </tr>
              <tr *ngFor="let mov of listmov.groupItem">
                <td>
                  <mdb-checkbox [checked]="mov.additionalInfo.checked"
                    (change)='checkDetalle(mov.additionalInfo,$event,  mov)'>
                  </mdb-checkbox>
                </td>
                <td></td>
                <td></td>
                <td>{{mov.folio}}</td>
                <td>{{mov.rutFormato | rut}}</td>
                <td>{{mov.cliente_nombre}}</td>
                <td>{{mov.comuna}}</td>
                <td>{{mov.vendedor}}</td>
                <td>{{mov.nombreFormato}}</td>
                <td>{{mov.cantidadRequerida | numerico}}</td>
                <td>{{mov.stockActual | numerico}}</td>
                <td class="text-center" style="font-weight: bold;">

                  <!-- <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                              *ngIf="mov.estadoAnalisisCodigo === 0">
                              {{movimiento.estado}}
                          </button> -->
                  <mdb-badge pill="true" info="true" *ngIf="mov.estadoAnalisisCodigo === 0">
                    {{mov.estado}}</mdb-badge>

                  <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                    (click)="loadAndShowModalDetalleMov(mov)" *ngIf="mov.estadoAnalisisCodigo === 1">
                    {{mov.estado}}
                  </button>

                  <mdb-badge pill="true" warning="true" *ngIf="mov.estadoAnalisisCodigo === 2">
                    {{mov.estado}}</mdb-badge>


                  <!-- Quiebre con algo atendido => Atendible Parcialmente (amarillo) -->
                  <mdb-badge pill="true" warning="true"
                    *ngIf="mov.estadoAnalisisCodigo === 3 && mov.diferenciaConStock < mov.cantidadRequerida">
                    Atendible Parcialmente
                    {{mov.diferenciaConStock | numerico}}
                  </mdb-badge>
                  <!-- Quiebre total: nada atendido (rojo) -->
                  <mdb-badge pill="true" danger="true"
                    *ngIf="mov.estadoAnalisisCodigo === 3 && mov.diferenciaConStock >= mov.cantidadRequerida">
                    {{mov.estado}}
                    {{mov.diferenciaConStock | numerico}}
                  </mdb-badge>
                </td>
                <td style="font-weight: bold;">
                  <button mdbBtn type="button" color="default" mdbWavesEffect class="btn text-center" size="sm"
                    [ngClass]="{'invisible': mov.estadoAnalisisCodigo !== 3}"
                    (click)="loadAndShowModalCambioProducto(mov)">
                    Cambiar
                  </button>
                  <button mdbBtn type="button" color="info" mdbWavesEffect class="btn" size="sm"
                    (click)="loadAndShowModalPedidos(mov.detalleAnalisisDemanda)">
                    Pedidos
                  </button>
                  <!-- <button size="sm" mdbBtn type="button" color="secondary" mdbWavesEffect class="btn btn-sm" (click)="OnEditNotaVenta(mov)">
                            <mdb-icon fas icon="pen"></mdb-icon> Editar Nota Venta
                          </button> -->
                </td>

            </ng-container>

          </tbody>

          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="groupArr?.length > 0"></app-pagination>
        </table>
      </div>
      <div class="table-responsive" *ngIf="listaMovimientos?.length > 0">
        <table class="table table-striped table-hover table-sm align-middle">
          <tbody>
            <tr>
              <td class="col-10" style="font-weight: bold; font-size: 15px;text-align: right;">
                <span style="color: red;">Bultos Atendidos </span>
                <span>{{sumTotalAt | numerico}}</span>
              </td>
              <td class="" style="font-weight: bold; font-size: 15px;text-align: left;">
                <span style="color: red;">Bultos Quiebre </span>
                <span>{{sumTotalQuiebre | numerico}}</span>
              </td>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="card mb-2 wow" *ngIf="listaMovimientos && listaMovimientos.length > 0">


    <div class="card-body d-sm-flex p-1 justify-content-between">

      <!-- EXCEL RESUMEN -->
      <div class="card-body d-sm-flex p-1"
        *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && listaMovimientosResumen?.length > 0">
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="obtenerAnalisisExcel(true)"
          *ngIf="listaMovimientos && listaMovimientos.length > 0">
          Excel
        </button>
        <!-- <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"  (click)="downloadPdf()"
        *ngIf="listaMovimientos && listaMovimientos.length > 0">
          PDF
        </button> -->
      </div>

      <!-- EXCEL DETALLE -->
      <div class="card-body d-sm-flex p-1"
        *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && listaMovimientos?.length > 0">
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="obtenerAnalisisExcel(false)"
          *ngIf="listaMovimientos && listaMovimientos.length > 0">
          Excel
        </button>
      </div>

      <app-api-button [processing]="processing" (click2)="procesarResultadoAnalisis()"
        *ngIf="listaMovimientos && listaMovimientos.length > 0">
        Paso siguiente
        <mdb-icon fas icon="arrow-right"></mdb-icon>
      </app-api-button>

    </div>
  </div>
</div>

<div *ngIf="showEdit == true">
  <h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Nota de venta
  </h1>

  <!-- Heading -->
  <div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
      <p class="mb-0">
        <span class="grey-text">Ventas</span>
        <span> /</span>
        <span>Nota de venta</span>
      </p>
    </div>
  </div>
</div>

<!-- APP-MODAL-EDITAR-NOTA-VENTA -->
<app-editar-nota-venta [childMessage]="seleccionNotaVentaEsp" (onSuccess)="OnCloseEditAdd($event);"
  (onSaveNotaVenta)="onUpdateFiltro();"></app-editar-nota-venta>


<!-- MODAL Detalle Movimientos -->
<app-modal-detalle-movimientos></app-modal-detalle-movimientos>

<!-- MODAL Cambiar producto-->
<app-modal-cambio-producto (onSuccess)="onCambioProductoRealizado()"></app-modal-cambio-producto>

<!-- MODAL Pedidos -->
<app-modal-pedidos></app-modal-pedidos>

<!-- MODAL CONFIRMACION -->
<app-modal-confirm [title]="modalConfirmTitle" [contentText]="modalConfirmContent">
</app-modal-confirm>

<!-- MODAL PRECIO CERO -->
<app-modal-ver-errores></app-modal-ver-errores>